import { iconNames } from 'lucide-react/dynamic';

/** A Lucide icon name (kebab-case) → true when lucide-react can draw it. The kit's SHARED icon set:
 * the Flutter kit resolves the same names from the bundled Lucide font (lucide_icons.g.dart). */
const LUCIDE_NAMES = new Set(iconNames);

/** Normalise an authored icon name to Lucide's kebab-case id (`MapPin` / `map_pin` → `map-pin`). */
export function lucideIconName(name) {
  return String(name || '')
    .trim()
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/_/g, '-')
    .toLowerCase();
}

export function isLucideIconName(name) {
  return typeof name === 'string' && LUCIDE_NAMES.has(lucideIconName(name));
}
